import styled from 'styled-components'
import { media } from 'sidecar-design-library'

export const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const IframeContainer = styled.div`
  position: relative;
  padding-right: 50%;
  padding-left: 50%;
  padding-bottom: ${p => (p.hasVideoContent ? '100%' : '50%')};
  li {
    margin-bottom: 1.25rem;
  }
  ${media.desktopAndUp`
    min-width: 500px;
  `}
  ${media.belowDesktop`
    padding-bottom: 100%;
  `}
  ${media.belowTablet`
    width: 100%;
  `}
`
